import { callFunction } from "./functions-client";

export interface Review {
  id: string;
  rating: number;
  body: string | null;
  created_at: string;
  author_account_id: string;
  author_name: string | null;
}
export interface ReviewAggregate { avg: number; count: number }

export const listReviews = (profileId: string) =>
  callFunction<{ reviews: Review[]; aggregate: ReviewAggregate; me: string }>(`reviews/list?profile_id=${encodeURIComponent(profileId)}`, { method: "GET" });
export const canReview = (profileId: string) =>
  callFunction<{ can: boolean; reason: string }>(`reviews/can?profile_id=${encodeURIComponent(profileId)}`, { method: "GET" });
export const submitReview = (subject_profile_id: string, rating: number, body?: string) =>
  callFunction<{ review: Review }>("reviews/submit", { body: { subject_profile_id, rating, body } });
export const removeReview = (subject_profile_id: string) =>
  callFunction<{ ok: boolean }>("reviews/remove", { body: { subject_profile_id } });
